import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ---- Public ----
export const submitQuote = (data) => axios.post(`${API}/quotes`, data).then((r) => r.data);
export const submitBooking = (data) => axios.post(`${API}/bookings`, data).then((r) => r.data);
export const getAvailability = () => axios.get(`${API}/availability`).then((r) => r.data);
export const getBlog = () => axios.get(`${API}/blog`).then((r) => r.data);
export const getBlogPost = (slug) => axios.get(`${API}/blog/${slug}`).then((r) => r.data);
export const getContent = () => axios.get(`${API}/content`).then((r) => r.data);

// ---- Admin (Bearer token) ----
const TOKEN_KEY = "totl_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const admin = axios.create({ baseURL: API });
admin.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const login = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const me = () => admin.get(`/auth/me`).then((r) => r.data);

// generic CRUD
export const adminList = (coll) => admin.get(`/admin/content/${coll}`).then((r) => r.data);
export const adminCreate = (coll, body) => admin.post(`/admin/content/${coll}`, body).then((r) => r.data);
export const adminUpdate = (coll, id, body) => admin.put(`/admin/content/${coll}/${id}`, body).then((r) => r.data);
export const adminDelete = (coll, id) => admin.delete(`/admin/content/${coll}/${id}`).then((r) => r.data);

export const getSettings = () => admin.get(`/admin/settings`).then((r) => r.data);
export const saveSettings = (body) => admin.put(`/admin/settings`, body).then((r) => r.data);

export const getQuotes = () => admin.get(`/admin/quotes`).then((r) => r.data);
export const getQuoteDetail = (id) => admin.get(`/admin/quotes/${id}`).then((r) => r.data);
export const setQuoteStatus = (id, status) => admin.patch(`/admin/quotes/${id}`, { status }).then((r) => r.data);

export const getBookings = () => admin.get(`/admin/bookings`).then((r) => r.data);
export const setBookingStatus = (id, status) => admin.patch(`/admin/bookings/${id}`, { status }).then((r) => r.data);

export const getBlocked = () => admin.get(`/admin/blocked-dates`).then((r) => r.data);
export const addBlocked = (date) => admin.post(`/admin/blocked-dates`, { date }).then((r) => r.data);
export const removeBlocked = (date) => admin.delete(`/admin/blocked-dates/${date}`).then((r) => r.data);

export const getUsers = () => admin.get(`/auth/users`).then((r) => r.data);
export const createUser = (body) => admin.post(`/auth/users`, body).then((r) => r.data);
export const deleteUser = (id) => admin.delete(`/auth/users/${id}`).then((r) => r.data);

export const exportUrl = (kind) => `${API}/admin/quotes-export/${kind}?token=${getToken()}`;
export const downloadExport = async (kind) => {
  const res = await admin.get(`/admin/quotes-export/${kind}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `quotes.${kind}`; a.click();
  window.URL.revokeObjectURL(url);
};
export const downloadBackup = async () => {
  const res = await admin.get(`/admin/backup`, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `backup.json`; a.click();
  window.URL.revokeObjectURL(url);
};
export const restoreBackup = (data) => admin.post(`/admin/restore`, data).then((r) => r.data);

// ---- Dashboard / analytics / reports ----
export const getStats = () => admin.get(`/admin/stats`).then((r) => r.data);
export const getCustomers = () => admin.get(`/admin/customers`).then((r) => r.data);
export const getNotifications = () => admin.get(`/admin/notifications`).then((r) => r.data);
export const getSeo = () => admin.get(`/admin/seo`).then((r) => r.data);
export const updateUser = (id, body) => admin.patch(`/auth/users/${id}`, body).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  admin.post(`/auth/change-password`, { current_password, new_password }).then((r) => r.data);

export const downloadBookingsExport = async (kind) => {
  const res = await admin.get(`/admin/bookings-export/${kind}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `appointments.${kind}`; a.click();
  window.URL.revokeObjectURL(url);
};

// stored auto/manual backups
export const listStoredBackups = () => admin.get(`/admin/backups`).then((r) => r.data);
export const runBackup = () => admin.post(`/admin/backups/run`).then((r) => r.data);
export const restoreStoredBackup = (id) => admin.post(`/admin/backups/${id}/restore`).then((r) => r.data);
export const downloadStoredBackup = async (id) => {
  const res = await admin.get(`/admin/backups/${id}/download`, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `backup-${id}.json`; a.click();
  window.URL.revokeObjectURL(url);
};

// ---- Studio (YosiMedia agency portal, super_admin only) ----
export const studioListSites = () => admin.get(`/studio/sites`).then((r) => r.data);
export const studioCreateSite = (data) => admin.post(`/studio/sites`, data).then((r) => r.data);
export const studioUpdateSite = (id, data) => admin.put(`/studio/sites/${id}`, data).then((r) => r.data);
export const studioDeleteSite = (id) => admin.delete(`/studio/sites/${id}`).then((r) => r.data);
export const studioOverview = () => admin.get(`/studio/overview`).then((r) => r.data);

export default API;
